import { Component, OnInit,ViewChild } from "@angular/core";
import * as fileSaver from "file-saver";

import { TodaysBirthdayService } from "../service/api/todays-birthday.service";
import { todaysEventInterface } from "../service/todays-event.interface";


@Component({
  selector: "app-birthday-list",
  templateUrl: "./birthday-list.component.html",
  styleUrls: ["./birthday-list.component.scss"],
})
export class BirthdayListComponent implements OnInit {
  cols: any[];
  isPagination: boolean = true;
  birthdayData: any[] = [];
  birthdayObj: todaysEventInterface;
  count: number;
  excelPopupVisible: boolean = false;
  availableFields: any[] = []; 
  selectedFields: any[] ; // User-selected fields
  selectAll: boolean = false;
  isCalendarVisible: boolean = false;
  selectedDate: Date;
  dateFrom: Date | null = null;
  filterFlag: boolean = false;
  loading: boolean = false;
  //today: Date = new Date();
  isFilterApplied: boolean = false;
  @ViewChild('calendarFilter', { static: false }) calendarFilter: any;

  constructor(private service: TodaysBirthdayService) {}

  getBirthdayData() {
    this.service.getTodaysBirthday().subscribe((res: any) => {
      this.birthdayData = res;
      this.count = this.birthdayData.length;
    });
  }

  sendSms() {
    this.service.sendSms("BIRTHDAY", this.birthdayData).subscribe();
    setTimeout(() => {
      this.getBirthdayData();
    }, 500);
  }

  tableColumns() {
    this.cols = [
      { field: "name", header: "Name" },
      { field: "phone", header: "Mobile Number" },
      { field: "role", header: "Role" },
     
    ];
  }

  refreshData() {
    this.service.getTodaysBirthdayOnRefresh().subscribe((res: any) => {
      this.birthdayData = res;
      this.count = this.birthdayData.length;
      //window.location.reload();
    });
  }

  ngOnInit() {
    this.tableColumns();
    this.getBirthdayData();
  }

  openExcelPopup() {
  
   this.service.getExcelFields().subscribe((res: any) => {
     console.log('res',res);
     this.availableFields = res.map(field => ({
       ...field, // Assuming API returns displayName
       value: field.value, // Assuming API returns field name
       selected: field.isPreload
     }));
     this.excelPopupVisible = true;
   });
   
   
  }
  
  // Collect selected fields and download Excel
  downloadSelectedFields() {
   const selectedFields = this.availableFields
     .filter(field => field.selected) // Only selected fields
     .map(({ label, value }) => ({ label, value , default: "--"})); // Sending correct format
  
   console.log('Selected Fields Sent to API:', selectedFields);
  
   if (selectedFields.length === 0) {
     alert('Please select at least one field.');
     return;
   }
   console.log('Sent to API:', selectedFields); 

   const formatDate = (date) => {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); // Adjust to local timezone
    return d.toISOString().split('T')[0]; // Extract YYYY-MM-DD part
  };

  const formattedDate = this.dateFrom ? formatDate(this.dateFrom) : formatDate(new Date()); // Default to today if not selected
    const requestPayload = {
      selectedFields: selectedFields,
      date: formattedDate // Sending formatted date
    }; 
   // Ensure we're sending the correctly filtered fields
   this.service.getCSV(requestPayload).subscribe((res) => {
     console.log('CSV Response:', res);
     
     var blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
     fileSaver.saveAs(blob, "Todays Birthday.csv");
   });
  
   this.excelPopupVisible = false;
  }
  toggleCalendar() {
    this.isCalendarVisible = !this.isCalendarVisible;
  }

  // applyDateFilter() {
  //   console.log('Selected Date:', this.selectedDate);
  //   this.isCalendarVisible = false; 
  // }

  filterBirthdaysByDate(): Promise<void> {
    return new Promise((resolve, reject) => {
        const selectedDate = this.formatDate(this.dateFrom); 
        
        this.service.getBirthdaysByDate(selectedDate).subscribe(
            (res: any) => {
                if (res && res.birthdays && Array.isArray(res.birthdays)) {
                    this.birthdayData = [...res.birthdays]; 
                    this.count = res.birthdayCount; 
                    this.filterFlag = true;
                } else {
                    this.birthdayData = [];
                    this.count = 0;
                }
                resolve(); 
            },
            (error) => {
                console.error("API Error:", error);
                reject(error); 
            }
        );
    });
}

  //format date as YYYY-MM-DD
  formatDate(date: Date): string {
    const d = new Date(date);
    return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
  }

  setFilterObject() {
    this.dateFrom = null; 
    this.isCalendarVisible = false; 
    this.filterFlag = false;
    this.getBirthdayData(); 
    
  }
 
  
  async applyDateFilter() {
    if (!this.dateFrom) return;

    this.loading = true; 

    try {
        await this.filterBirthdaysByDate(); 
        this.isFilterApplied = true;
    } catch (error) {
        console.error("Error filtering birthdays:", error);
    } finally {
        this.loading = false; 
        if (this.calendarFilter) {
            this.calendarFilter.hide();
        }
    }
}

  cancelDateFilter() {
    this.dateFrom = null;
    this.isFilterApplied = false;
    if (this.calendarFilter) {
      this.calendarFilter.hide(); // Hide the overlay
    }
  }
  filterEighteenYearOlds() {
    this.loading = true; // Show loading spinner
  
    // Call the API to get 18-year-olds
    this.service.getEighteenYearOlds().subscribe(
      (res: any) => {
        this.birthdayData = res; // Assuming the API returns the list of 18-year-olds
        this.count = this.birthdayData.length; // Update the count
        this.filterFlag = true;
        this.loading = false; // Hide loading spinner
      },
      (error) => {
        console.error("Error fetching 18-year-olds:", error);
        this.loading = false; // Hide loading spinner in case of error
      }
    );
  }
  
  
}
  

